// Selling features shown beside the Producer option on /register.
//
// Deliberately shorter than the Agent and Casting panels: this one sits on
// screen only until ProducerRedirectStep hands the visitor to the producer
// site, so it is written to be read in that window rather than browsed.
//
// Note the sibling Director/ProducerSellingFeatures is a different product
// (the Producer Essentials masterclass, reached with ?subType=producer on a
// Casting account) — hence the fuller name here.

import React from "react";
import styled from "styled-components";
import { withI18n } from "react-i18next";
import * as SharedStyle from "../Common/StyledComponents";

interface IProps {
  t?: any;
}

const ProducerWorkbookSellingFeatures: React.FC<IProps> = ({ t }) => {
  return (
    <>
      <TitleWrapper>
        <MainTile>{t("Producer")}</MainTile>
      </TitleWrapper>
      <StyledP>
        {t("Every project begins with a vision. Now it has a home.")}
      </StyledP>
      <TitleWrapper>
        <Title>
          <SharedStyle.SellingFeatureIcon
            src="../images/files_labeled_outlined.svg"
            alt=""
            aria-hidden="true"
          />
          <div>{t("Projects")}</div>
        </Title>
      </TitleWrapper>
      <SharedStyle.SellingFeatureP>
        {t("Scripts, budgets, roles, shoot dates and cast, all in one place.")}
      </SharedStyle.SellingFeatureP>
      <TitleWrapper>
        <Title>
          <SharedStyle.SellingFeatureIcon
            src="../images/user_big_outlined.svg"
            alt=""
            aria-hidden="true"
          />
          <div>{t("CastLists")}</div>
        </Title>
      </TitleWrapper>
      <SharedStyle.SellingFeatureP>
        {t(
          "Built from IMDbPro and your own MasterCast, shared by link, exported as PDF."
        )}
      </SharedStyle.SellingFeatureP>
      <TitleWrapper>
        <Title>
          <SharedStyle.SellingFeatureIcon src="../images/trial_pitch.svg" />
          <div>{t("Pitch decks")}</div>
        </Title>
      </TitleWrapper>
      <SharedStyle.SellingFeatureP>
        {t("Sent to any collaborator or investor in seconds.")}
      </SharedStyle.SellingFeatureP>
    </>
  );
};

export default withI18n()(ProducerWorkbookSellingFeatures);

const TitleWrapper = styled.div`
  width: 100%;
`;

const MainTile = styled.div`
  font-size: 32px;
  font-weight: 600;
  line-height: 44px;
  color: #0a1f44 !important;
  margin-bottom: 12px;
`;

const Title = styled.div`
  display: flex;
  font-size: 21px;
  font-weight: 600;
  line-height: 29px;
  color: #364866 !important;
  margin-bottom: 12px;
`;

const StyledP = styled.p`
  font-size: 14px;
  color: #364866 !important;
  line-height: 25px;
`;
